module.exports = __webpack_public_path__ + "img/fyqd.344f76ce.png";